const DASHBOARD_WIDGET_KEYS = [
	"taskList",
	"myTeam",
	"map",
	"statistic",
	"notifications",
	"posts",
	"messages",
	"schedule",
	"timeoffPlans",
	"reports",
];

export const getDashboardWidgetKey = (layoutId) => {
	if (typeof layoutId === "string" && layoutId.startsWith("report-")) {
		return "reports";
	}
	return layoutId;
};

export const canViewDashboardWidget = (dashboardAccess, layoutId) => {
	const key = getDashboardWidgetKey(layoutId);
	if (!DASHBOARD_WIDGET_KEYS.includes(key)) {
		return true;
	}
	return !!dashboardAccess?.[key]?.canView;
};

export const filterDashboardWidgets = (dashboardAccess, items = []) =>
	items.filter((item) => canViewDashboardWidget(dashboardAccess, item.i));
